import { jsx as _jsx } from "react/jsx-runtime";
import { useBoolean } from '@fluentui/react-hooks';
import { defaultContext, appShellContext } from './contextAppShell';
import { FeaturePanelProvider } from '../../feature/FeaturePanel/FeaturePanelProvider';
/**
 * Data provider for AppShell's shared context.
 */
export const AppShellProvider = ({ appLinks = defaultContext.appLinks, children, featureList, portalHomeHref, portalName, }) => {
    const [isExpanded, setIsExpanded] = useBoolean(defaultContext.isAppSidebarExpanded);
    const value = Object.assign(Object.assign({}, defaultContext), { appLinks, appLinksWithHome: [
            {
                iconName: 'Home',
                name: portalName,
                url: portalHomeHref,
            },
            ...appLinks,
        ], isAppSidebarExpanded: isExpanded, toggleAppSidebar: setIsExpanded.toggle });
    return (_jsx(appShellContext.Provider, Object.assign({ value: value }, { children: _jsx(FeaturePanelProvider, Object.assign({ featureList: featureList, userInterface: portalName }, { children: children })) })));
};
